document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initFaq();
  initGallery();
  initVariants();
  initQtyTiers();
  initStickyBar();
  initShippingTimeline();
  initCouponCountdown();
});

function initCouponCountdown() {
  var banners = document.querySelectorAll('[data-nk-coupon-banner]');
  if (!banners.length) return;

  function update(el) {
    var endAttr = el.getAttribute('data-end');
    if (!endAttr) return;
    var end = new Date(endAttr.replace(' ', 'T'));
    var timerEl = el.querySelector('[data-nk-coupon-timer]');
    var msLeft = end - new Date();

    if (isNaN(end.getTime())) return;

    if (msLeft <= 0) {
      el.style.display = 'none';
      return;
    }

    var days = Math.floor(msLeft / 86400000);
    var hours = Math.floor((msLeft % 86400000) / 3600000);
    var mins = Math.floor((msLeft % 3600000) / 60000);
    var secs = Math.floor((msLeft % 60000) / 1000);

    if (timerEl) {
      if (days > 0) {
        timerEl.textContent = days + 'd ' + String(hours).padStart(2, '0') + 'h ' + String(mins).padStart(2, '0') + 'min';
      } else {
        timerEl.textContent = String(hours).padStart(2, '0') + ':' + String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
      }
    }
  }

  banners.forEach(function (el) {
    update(el);
    setInterval(function () { update(el); }, 1000);
  });
}

function initShippingTimeline() {
  var els = document.querySelectorAll('[data-nk-shipping-timeline]');
  if (!els.length) return;

  var months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sept', 'oct', 'nov', 'dic'];

  function addDays(date, days) {
    var d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  }

  function formatRange(dateMin, dateMax) {
    if (dateMin.getMonth() === dateMax.getMonth()) {
      return dateMin.getDate() + ' - ' + dateMax.getDate() + ' ' + months[dateMin.getMonth()];
    }
    return dateMin.getDate() + ' ' + months[dateMin.getMonth()] + ' - ' + dateMax.getDate() + ' ' + months[dateMax.getMonth()];
  }

  function update(el) {
    var cutoffHour = parseInt(el.getAttribute('data-cutoff-hour'), 10) || 16;
    var shipMin = parseInt(el.getAttribute('data-ship-min'), 10) || 0;
    var shipMax = parseInt(el.getAttribute('data-ship-max'), 10) || shipMin;
    var deliveryMin = parseInt(el.getAttribute('data-delivery-min'), 10) || 1;
    var deliveryMax = parseInt(el.getAttribute('data-delivery-max'), 10) || deliveryMin;

    var now = new Date();
    var cutoffToday = new Date(now);
    cutoffToday.setHours(cutoffHour, 0, 0, 0);

    var beforeCutoff = now < cutoffToday;
    var cutoffTarget = beforeCutoff ? cutoffToday : addDays(cutoffToday, 1);
    var baseDate = beforeCutoff ? new Date(now) : addDays(now, 1);

    var msLeft = cutoffTarget - now;
    var hLeft = Math.floor(msLeft / 3600000);
    var mLeft = Math.floor((msLeft % 3600000) / 60000);
    var countdownEl = el.querySelector('[data-nk-countdown]');
    if (countdownEl) {
      countdownEl.textContent = String(hLeft).padStart(2, '0') + 'h ' + String(mLeft).padStart(2, '0') + 'min';
    }

    var shipDateMin = addDays(baseDate, shipMin);
    var shipDateMax = addDays(baseDate, shipMax);
    var shipEl = el.querySelector('[data-nk-ship-date]');
    if (shipEl) shipEl.textContent = formatRange(shipDateMin, shipDateMax);

    var deliveryDateMin = addDays(shipDateMin, deliveryMin);
    var deliveryDateMax = addDays(shipDateMax, deliveryMax);
    var deliveryEl = el.querySelector('[data-nk-delivery-date]');
    if (deliveryEl) deliveryEl.textContent = formatRange(deliveryDateMin, deliveryDateMax);
  }

  els.forEach(function (el) {
    update(el);
    setInterval(function () { update(el); }, 60000);
  });
}

function initStickyBar() {
  var bars = document.querySelectorAll('[data-nk-sticky-bar]');
  bars.forEach(function (bar) {
    var wrap = bar.closest('section');
    if (!wrap) return;
    var mainBtn = wrap.querySelector('[data-nk-add-btn]');
    if (!mainBtn) return;
    var stickyBtn = bar.querySelector('[data-nk-sticky-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () { mainBtn.click(); });
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('nk-visible-bar', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    observer.observe(mainBtn);
  });
}

function initReveal() {
  var els = document.querySelectorAll('.nk-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('nk-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nk-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initFaq() {
  var items = document.querySelectorAll('.nk-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.nk-faq-q');
    var answer = item.querySelector('.nk-faq-a');
    if (!btn || !answer) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('nk-open');
      items.forEach(function (other) {
        other.classList.remove('nk-open');
        var a = other.querySelector('.nk-faq-a');
        if (a) a.style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('nk-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
}

function initGallery() {
  var galleries = document.querySelectorAll('[data-nk-gallery]');
  galleries.forEach(function (gallery) {
    var main = gallery.querySelector('[data-nk-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-nk-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var posterSrc = thumb.getAttribute('data-full');
        if (!posterSrc) return;
        var isVideo = thumb.getAttribute('data-media-type') === 'video';
        var videoSrc = thumb.getAttribute('data-video-src');
        thumbs.forEach(function (t) { t.classList.remove('nk-active'); });
        thumb.classList.add('nk-active');
        if (isVideo && videoSrc) {
          main.innerHTML = '<video autoplay muted loop playsinline controls width="700" height="700" poster="' + posterSrc + '"><source src="' + videoSrc + '" type="video/mp4"></video>';
        } else {
          main.innerHTML = '<img src="' + posterSrc + '" alt="" loading="lazy" width="700" height="700">';
        }
      });
    });
  });
}

function initQtyTiers() {
  var groups = document.querySelectorAll('[data-nk-qty-tiers]');
  groups.forEach(function (group) {
    var tiers = group.querySelectorAll('[data-nk-tier]');
    var qtyInput = group.querySelector('[data-nk-qty-input]');
    var discountInput = group.querySelector('[data-nk-discount-input]');
    if (!tiers.length) return;

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        tiers.forEach(function (t) { t.classList.remove('nk-selected'); });
        tier.classList.add('nk-selected');
        if (qtyInput) qtyInput.value = tier.getAttribute('data-qty') || '1';
        if (discountInput) discountInput.value = tier.getAttribute('data-code') || '';
      });
    });

    var form = group.closest('form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var addBtn = form.querySelector('[data-nk-add-btn]');
      var idInput = form.querySelector('input[name="id"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var code = discountInput ? discountInput.value : '';
      if (addBtn) addBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: idInput ? idInput.value : undefined, quantity: qty })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add to cart failed');
          if (code) {
            window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          if (addBtn) addBtn.disabled = false;
          form.submit();
        });
    });
  });
}

function initVariants() {
  var forms = document.querySelectorAll('[data-nk-product-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-nk-variants-json]');
    if (!dataEl) return;
    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('[data-nk-price]');
    var compareEl = form.querySelector('[data-nk-compare]');
    var addBtn = form.querySelector('[data-nk-add-btn]');
    var optionGroups = form.querySelectorAll('[data-nk-option-group]');

    function currentSelection() {
      var selected = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.nk-option-value.nk-selected');
        selected.push(active ? active.getAttribute('data-value') : null);
      });
      return selected;
    }

    function findVariant() {
      var sel = currentSelection();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      });
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR'
      });
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-text-unavailable') || 'No disponible'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-text-add') || 'Añadir al carrito';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-text-soldout') || 'Agotado';
        }
      }
    }

    optionGroups.forEach(function (group) {
      var values = group.querySelectorAll('.nk-option-value');
      values.forEach(function (val) {
        val.addEventListener('click', function () {
          values.forEach(function (v) { v.classList.remove('nk-selected'); });
          val.classList.add('nk-selected');
          updateUI();
        });
      });
    });

    updateUI();
  });
}
